<template>
  <div>
    <ManageEventSeedars />
    <EditEventDetailModal :association_id="association_id" :events="events" />
    <ShareEvent :association_id="association_id" :events="events" />
    <div class="event-sec-top sec-top p-0 align-items-start align-items-md-end" v-if="events && showLoader == 0">
      <div class="left-part">
        <div class="content" v-if="events && events.exactStartDate && events.exactEndDate">
          {{ formatDateRange(events.exactStartDate, events.exactEndDate) }}
          <span class="ml-1" v-if="events.time_zone">({{ formatTimeZone(events?.time_zone) }})</span>
        </div>
        <h3 class="text-capitalize">{{ events.eventName }}</h3>
        <p class="single-asso-type">
          {{ events.association }} - {{ events.eventType }}
        </p>
      </div>
      <div class="right-part asso-right-part mt-2 mt-md-0">
        <div class="d-flex align-items-center justify-content-end" style="gap: 10px;">

          <!-- <div class="follow-unfollow-btns ">

            <button class="follow-btn" @click="$root.$emit('openShareEventModal')">
              <img :src="follow" alt="follow" /> Share
            </button>

          </div> -->
          <div class="follow-unfollow-btns w-100 d-flex justify-content-end">
            <template v-if="!showFollowLoader">

              <template v-if="events && events?.event_follower">
                <button class="follow-btn" @click.stop="unFollowEvent(events)">
                  <img :src="follow" alt="follow" />
                </button>
              </template>

              <!-- Follow Button -->
              <template v-else>
                <button class="unfollow-btn" @click.stop="followEvent(events)">
                  <img :src="unfollow" alt="unfollow" />
                  <span>Follow</span>
                </button>
              </template>
            </template>

            <!-- Loader Spinner -->
            <button class="unfollow-btn position-relative" v-if="showFollowLoader">
              <div class="lds-dual-ring"></div>
            </button>
          </div>
          <button class="btn btn-primary w-100" @click="goToPoolPlayGenerator()" v-if="currentIsAdmin == '1'">
            <img src="../../assets/Svg/matchGeni.svg" alt="" class="mr-1" />
            <span>MatchGeni</span>
          </button>
          <div class="opt opt-manage position-relative mt-0 cursor-pointer" @click="openAttendeeOptions"
            v-click-outside="onClickOutside" v-if="currentIsAdmin == '1'">
            <img src="../../assets/Svg/setting-grey.svg" alt="" />
            <div class="sub-setting-options" v-if="attendeesOptions">
              <ul class="d-block pb-0">
                <li v-if="currentIsAdmin == '1'" @click="callModalForSeedar()">
                  <img src="../../assets/Svg/seed-criteria.svg" alt="seed criteria" />
                  Seed Criteria
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="products-list-shim p-0" v-if="showLoader == 1">
      <content-placeholders :rounded="true">
        <content-placeholders-text :lines="3" />
      </content-placeholders>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ManageEventSeedars from "./Modals/ManageEventSeedars.vue"
import ShareEvent from "./Modals/ShareEvent.vue"
import EditEventDetailModal from "../Teams/ChatRight/ChatEvents/EditEventDetailModal.vue";
export default {
  name: "AssociationEventsTop",
  components: {
    ManageEventSeedars,
    EditEventDetailModal,
    ShareEvent,
  },
  data() {
    return {
      editEventOption: false,
      user_id: localStorage.getItem("userId"),
      unfollow: require("../../assets/Svg/unfollow.svg"),
      follow: require("../../assets/Svg/follow.svg"),
      attendeesOptions: false,
      showFollowLoader: false,
    };
  },
  methods: {
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    closeMenu() {
      this.showMenu = false;
    },
    // callModal(data) {
    //   this.$root.$emit("updateEditEventDetailModal", data);
    // },

    openAttendeeOptions() {
      this.attendeesOptions = !this.attendeesOptions;
    },
    onClickOutside() {
      this.attendeesOptions = false;
    },
    goToPoolPlayGenerator() {
      this.$router.push({ name: 'PoolPlayGenerator', params: { id: this.events.guid },  query: { view: 'default' } });
    },
    openEditEventOption() {
      this.editEventOption = !this.editEventOption;
    },
    onClickOutsidee() {
      this.editEventOption = false;
    },
    async followEvent(event) {
      if (this.proStatus === null && !event.isUmpireOrAdmin) {
        this.$fire({
          title: "Free users cannot follow events. Upgrade to Pro to follow events.",
          showCancelButton: true,
          confirmButtonText: "Go Pro",
          cancelButtonText: "Cancel",
        }).then((result) => {
          if (result.dismiss === "cancel" || result.dismiss === "backdrop") {
            return; // Prevents redirection
          }
          // Redirect only if "Go Pro" is clicked
          this.$router.push({ path: `/go-pro/${this.encryptedKey}/customer-session-link/${this.customerSessionSecret}` });
        });
        return; // Stop execution if proStatus is null
      }

      this.showFollowLoader = true;

      try {
        const formData = new FormData();
        formData.append("event_id", event.id);
        formData.append("user_id", this.user_id);

        // API Call
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}eventfollower/store`,
          formData
        );

        if (response.data.statusCode === 200) {
          const eventFollow = response.data.data.follower;

          // Assign the follower data
          event.event_follower = eventFollow;
          this.$emit('followed');
        } else {
          this.errorMessage = response.data.message || "Failed to follow the event.";
        }
      } catch (error) {
        console.error("Follow Event API Error:", error);
        this.errorMessage = "Failed to fetch data. Please try again.";
      } finally {
        // Stop loader always
        this.showFollowLoader = false;
      }
    },

    async unFollowEvent(event) {
      if (!event || !event.event_follower) return;

      this.showFollowLoader = true;

      try {
        const formData = new FormData();
        formData.append("follow_id", event.event_follower.id);

        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}eventfollower/unfollow`,
          formData
        );

        if (response.data.statusCode === 200) {
          // Remove follower data
          event.event_follower = null;
          this.$emit('unfollowed'); // Emit event to parent
        } else {
          this.errorMessage = response.data.message || "Failed to unfollow the event.";
        }
      } catch (error) {
        console.error("Unfollow Event API Error:", error);
        this.errorMessage = "Failed to fetch data. Please try again.";
      } finally {
        // Stop loader always
        this.showFollowLoader = false;
      }
    },
    openGoogleMap(item) {
      const strlatLng = item["lan"] + "," + item["long"];
      const urlSuffix = strlatLng
        ? strlatLng
        : item["address"] + ", " + item["city"] + ", " + item["zipCode"];

      window.open(
        "https://www.google.com/maps/search/?api=1&query=" + urlSuffix,
        "_blank"
      );
    },
    formatDateRange(startDate, endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);

      const startDateString = start.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
      });
      const endDateString = end.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
      });
      const startYear = start.getFullYear();
      const endYear = end.getFullYear();

      if (startYear === endYear) {
        return `${startDateString} to ${endDateString}, ${startYear}`;
      } else {
        return `${startDateString}, ${startYear} to ${endDateString}, ${endYear}`;
      }
    },
    formatTimeZone(timeZone) {
      if (timeZone && typeof timeZone === 'string') {
        return timeZone.replace(/\(UTC[^)]+\)\s*/, "").trim(); // Removes text like "(UTC-06:00)"
      }
      return timeZone; // Return the original value if it's not a valid string
    },
    callModalForSeedar() {
      this.$root.$emit("openManageEventSeedarsModal", {
        eventId: this.eventId,
        association_id: this.association_id
      });
    }
  },
  props: {
    events: {
      type: Object,
      required: true,
      default: () => ({})
    },
    association_id: {
      type: [Number, String],
    },
    currentIsAdmin: {
      type: String,
    },
    showLoader: {
      type: Number,
    },
    eventId: {
      type: [Number, String],
    },
  },
  mounted() {

  },
};
</script>